
import Vue from "vue";

export default Vue.extend({
  name: "MemberBadge",
  props: {
    tagId: Number,
    name: String,
  },
  computed: {
    memberColor(): string {
      let result = "badge member-badge ";
      switch (this.tagId) {
        case 2:
          result += "white";
          break;
        case 3:
          result += "purple";
          break;
        case 4:
          result += "blue";
          break;
        case 5:
          result += "yellow";
          break;
        case 6:
          result += "green";
          break;
        case 7:
          result += "pink";
          break;
        case 8:
          result += "orange";
          break;
        case 9:
          result += "aqua";
          break;
        case 10:
          result += "red";
          break;
        default:
          result.trim();
          break;
      }
      return result;
    },
    defaultName(): string {
      switch (this.tagId) {
        case 2:
          return "律月ひかる";
        case 3:
          return "北美梨寧";
        case 4:
          return "葉月結菜";
        case 5:
          return "安杜羽加";
        case 6:
          return "吉瀬真珠";
        case 7:
          return "橘花怜";
        case 8:
          return "桜ひなの";
        case 9:
          return "藤谷美海";
        case 10:
          return "伊達花彩";
        default:
          return "Unknown";
      }
    },
  },
});
